"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.useCart = useCart;
exports["default"] = void 0;
var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));
var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));
var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));
var _react = _interopRequireWildcard(require("react"));
var _jsCookie = _interopRequireDefault(require("js-cookie"));
var _swr = _interopRequireDefault(require("swr"));
var _router = _interopRequireDefault(require("next/router"));
var _TokenProvider = require("../../common/TokenProvider");
var _agent = require("@deosite/agent");
var _createParametrizedUrl = _interopRequireDefault(require("@deosite/helpers/createParametrizedUrl"));
var _mapCartData = require("@deosite/helpers/mapCartData");
var _fetcher = _interopRequireDefault(require("./fetcher"));
var _AccountProvider = require("../AccountProvider");
var _useErrorCart2 = _interopRequireDefault(require("../../common/useErrorCart"));
var _useMinicart2 = require("../../common/useMinicart");
var _usePromotions2 = _interopRequireDefault(require("../usePromotions"));
var _useAppConfiguration2 = _interopRequireDefault(require("@deosite/app/features/appConfiguration/useAppConfiguration"));
var _useShippingMethods2 = _interopRequireDefault(require("../../redux/useShippingMethods"));
var _useCheckoutData2 = _interopRequireDefault(require("../../redux/useCheckoutData"));
function _interopRequireWildcard(e, t) { if ("function" == typeof WeakMap) var r = new WeakMap(), n = new WeakMap(); return (_interopRequireWildcard = function _interopRequireWildcard(e, t) { if (!t && e && e.__esModule) return e; var o, i, f = { __proto__: null, "default": e }; if (null === e || "object" != typeof e && "function" != typeof e) return f; if (o = t ? n : r) { if (o.has(e)) return o.get(e); o.set(e, f); } for (var _t in e) { "default" !== _t && {}.hasOwnProperty.call(e, _t) && ((i = (o = Object.defineProperty) && Object.getOwnPropertyDescriptor(e, _t)) && (i.get || i.set) ? o(f, _t, i) : f[_t] = e[_t]); } return f; })(e, t); }
var __jsx = _react["default"].createElement;
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { (0, _defineProperty2["default"])(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
var CartContext = /*#__PURE__*/_react["default"].createContext({});
function CartProvider(props) {
  var isFirstRun = (0, _react.useRef)(true);
  var isErrorPending = (0, _react.useRef)(false);
  var children = props.children;
  var _useCheckoutData = (0, _useCheckoutData2["default"])(),
    clearData = _useCheckoutData.clearData,
    setBillingCountryFromCart = _useCheckoutData.setBillingCountryFromCart;
  var _useToken = (0, _TokenProvider.useToken)(),
    token = _useToken.token,
    deleteToken = _useToken.deleteToken;
  var _useAppConfiguration = (0, _useAppConfiguration2["default"])(),
    language = _useAppConfiguration.language,
    domain = _useAppConfiguration.domain;
  var _useState = (0, _react.useState)(true),
    isRevalidated = _useState[0],
    revalidate = _useState[1];
  var _useState2 = (0, _react.useState)({
      language: language,
      domain: domain
    }),
    languageAndDomain = _useState2[0],
    setLanguageAndDomain = _useState2[1];
  var _useMinicart = (0, _useMinicart2.useMinicart)(),
    setMinicartContentFromStorage = _useMinicart.setMinicartContentFromStorage,
    setCouponCodeFormPromotions = _useMinicart.setCouponCodeFormPromotions,
    minicartState = _useMinicart.minicartState;
  var _useState3 = (0, _react.useState)(null),
    cart = _useState3[0],
    setCart = _useState3[1];
  var _useAccount = (0, _AccountProvider.useAccount)(),
    accountData = _useAccount.accountData,
    setNewDataAfterLogin = _useAccount.setNewDataAfterLogin,
    clearAccountData = _useAccount.clearAccountData;
  var _useState4 = (0, _react.useState)(true),
    isItemsChange = _useState4[0],
    setItemChange = _useState4[1];
  var _useErrorCart = (0, _useErrorCart2["default"])(),
    checkErrorCart = _useErrorCart.checkErrorCart;
  var _useShippingMethods = (0, _useShippingMethods2["default"])(),
    shippingMethods = _useShippingMethods.shippingMethods;
  var _useState5 = (0, _react.useState)([]),
    productsWithQuantity = _useState5[0],
    setProductsWithQuantity = _useState5[1];
  var getCartId = function getCartId() {
    return _jsCookie["default"].get("cartId");
  };
  var getCartIdFromStorage = function getCartIdFromStorage() {
    if (typeof window === "undefined") return [];
    var cartIdInStorage = localStorage.getItem("cartId");
    return cartIdInStorage ? JSON.parse(cartIdInStorage) : null;
  };
  var getCartFromStorage = function getCartFromStorage() {
    if (typeof window === "undefined") return [];
    var cartInStorage = localStorage.getItem("minicartContent");
    return cartInStorage ? JSON.parse(cartInStorage) : [];
  };
  var removeMinicartDataFromStorage = function removeMinicartDataFromStorage() {
    localStorage.setItem("minicartContent", "[]");
    localStorage.removeItem("cartId");
  };
  var _useSWR = (0, _swr["default"])(getCartId() && !token ? [getCartId(), null, languageAndDomain] : null, _fetcher["default"]),
    guestCart = _useSWR.data,
    updateGuestCart = _useSWR.mutate;
  var _useSWR2 = (0, _swr["default"])(token ? [getCartId(), token, languageAndDomain] : null, _fetcher["default"]),
    customerCart = _useSWR2.data,
    updateCustomerCart = _useSWR2.mutate;
  (0, _react.useEffect)(function () {
    var _cartTemporary$respon, _cartTemporary$respon2, _cartTemporary$respon3, _cart$totals;
    var cartTemporary = token ? customerCart : guestCart;
    if (cartTemporary && cartTemporary !== null && cartTemporary !== void 0 && (_cartTemporary$respon = cartTemporary.response) !== null && _cartTemporary$respon !== void 0 && _cartTemporary$respon.statusCode && cartTemporary !== null && cartTemporary !== void 0 && (_cartTemporary$respon2 = cartTemporary.response) !== null && _cartTemporary$respon2 !== void 0 && (_cartTemporary$respon3 = _cartTemporary$respon2.body) !== null && _cartTemporary$respon3 !== void 0 && _cartTemporary$respon3.message) {
      handleResponseErrors(cartTemporary);
    }
    checkStorage();
    setBillingCountryFromCart();
    setMinicartContentFromStorage();
    if (cart !== null && cart !== void 0 && (_cart$totals = cart.totals) !== null && _cart$totals !== void 0 && _cart$totals.couponCode && !minicartState.isCouponCodeFormPromotions) {
      var _cart$totals2;
      isCouponFromPromotions(cart === null || cart === void 0 ? void 0 : (_cart$totals2 = cart.totals) === null || _cart$totals2 === void 0 ? void 0 : _cart$totals2.couponCode).then(function (hasCoupon) {
        return setCouponCodeFormPromotions(hasCoupon);
      });
    }
  }, [customerCart, guestCart]);
  (0, _react.useEffect)(function () {
    if (isFirstRun.current) {
      isFirstRun.current = false;
      checkStorage();
    }
  }, []);
  var checkStorage = function checkStorage() {
    var cartIdInStorage = localStorage.getItem("cartId");
    if (!_jsCookie["default"].get("cartId") && cartIdInStorage) {
      _jsCookie["default"].set("cartId", JSON.parse(cartIdInStorage));
    }
    if (cartIdInStorage) {
      var initialCartFromStorage = localStorage.getItem("minicartContent");
      setCart(initialCartFromStorage ? JSON.parse(initialCartFromStorage) : []);
    } else {
      localStorage.removeItem("minicartContent");
    }
  };
  var handleResponseErrors = /*#__PURE__*/function () {
    var _ref = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee(error) {
      var typeError, _global$__appConfig__, _global$__appConfig__2;
      return _regenerator["default"].wrap(function _callee$(_context) {
        while (1) {
          switch (_context.prev = _context.next) {
            case 0:
              typeError = checkErrorCart(error);
              if (!(typeError === (_useErrorCart2["default"] === null || _useErrorCart2["default"] === void 0 ? void 0 : _useErrorCart2["default"].LOGOUT) && !isErrorPending.current)) {
                _context.next = 12;
                break;
              }
              isErrorPending.current = true;
              _jsCookie["default"].remove("cartId");
              deleteToken();
              clearAccountData();
              clearData();
              updateCart(null, false);
              _router["default"].push((_global$__appConfig__ = global.__appConfig__.sessionExpiredReturnUrl) !== null && _global$__appConfig__ !== void 0 ? _global$__appConfig__ : "/login", "".concat((_global$__appConfig__2 = global.__appConfig__.sessionExpiredReturnUrl) !== null && _global$__appConfig__2 !== void 0 ? _global$__appConfig__2 : "/login", "?=session-expired"), {
                shallow: true
              }).then(function () {
                isErrorPending.current = false;
              });
              return _context.abrupt("return");
            case 12:
              if (!(typeError === (_useErrorCart2["default"] === null || _useErrorCart2["default"] === void 0 ? void 0 : _useErrorCart2["default"].REMOVE_CART) && !isErrorPending.current)) {
                _context.next = 24;
                break;
              }
              isErrorPending.current = true;
              _jsCookie["default"].remove("cartId");
              clearAccountData();
              clearData();
              updateCart(null, false);
              _context.next = 20;
              return createCart(token || null);
            case 20:
              setMinicartContentFromStorage();
              isErrorPending.current = false;
              if (_router["default"].router.asPath.includes("checkout")) {
                _router["default"].push("/");
              }
              return _context.abrupt("return");
            case 24:
              return _context.abrupt("return", typeError);
            case 25:
            case "end":
              return _context.stop();
          }
        }
      }, _callee);
    }));
    return function handleResponseErrors(_x) {
      return _ref.apply(this, arguments);
    };
  }();
  var updateCart = token ? updateCustomerCart : updateGuestCart;
  (0, _react.useEffect)(function () {
    var _cart$response, _cart$response2, _cart$response2$body;
    if (cart && cart !== null && cart !== void 0 && (_cart$response = cart.response) !== null && _cart$response !== void 0 && _cart$response.statusCode && cart !== null && cart !== void 0 && (_cart$response2 = cart.response) !== null && _cart$response2 !== void 0 && (_cart$response2$body = _cart$response2.body) !== null && _cart$response2$body !== void 0 && _cart$response2$body.message) {
      handleResponseErrors(cart);
    } else if (cart) {
      if (token && !(accountData !== null && accountData !== void 0 && accountData.customer)) {
        setNewDataAfterLogin();
      }
    }
  }, [cart]);
  (0, _react.useEffect)(function () {
    var _cart$items;
    var userJustFinishedCheckout = token && !getCartId();
    var guestWithoutCart = !getCartId() && !token;
    if (guestWithoutCart || userJustFinishedCheckout || (cart === null || cart === void 0 ? void 0 : (_cart$items = cart.items) === null || _cart$items === void 0 ? void 0 : _cart$items.length) === 0 || !isItemsChange) {
      return;
    }
    setItemChange(false);

    //Todo czy musimy tutaj zawsze wywolywac estimate shipping, czy wystarczy tylko w checkout? mamy sprobowac bez, decyzja Kamila
    //updateShipping({ token, cartId: getCartId() });
  }, [getCartId(), token, cart === null || cart === void 0 ? void 0 : cart.items]);
  var getCartTotals = function getCartTotals() {
    var _cart$totals3, _shipping, _cart$totals4, _cart$totals5, _cart$totals6, _cart$totals7;
    var onlyForCheckout = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
    var shippingPrice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
    var shipping = {};
    if (onlyForCheckout) {
      shipping = {
        price: shippingPrice
      };
    } else {
      shipping = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.find(function (method) {
        var _cart$shippingMethodP, _cart$shippingMethodP2;
        return cart !== null && cart !== void 0 && cart.isShippingMethodPicked ? cart === null || cart === void 0 ? void 0 : (_cart$shippingMethodP = cart.shippingMethodPicked) === null || _cart$shippingMethodP === void 0 ? void 0 : (_cart$shippingMethodP2 = _cart$shippingMethodP.includes) === null || _cart$shippingMethodP2 === void 0 ? void 0 : _cart$shippingMethodP2.call(_cart$shippingMethodP, method.id) : method.id === "tablerate";
      });
    }
    var shippingCost = cart !== null && cart !== void 0 && (_cart$totals3 = cart.totals) !== null && _cart$totals3 !== void 0 && _cart$totals3.couponCode ? cart.totals.shippingCost : ((_shipping = shipping) === null || _shipping === void 0 ? void 0 : _shipping.price) || 0;
    var cartTotalPrice = onlyForCheckout ? (cart === null || cart === void 0 ? void 0 : (_cart$totals4 = cart.totals) === null || _cart$totals4 === void 0 ? void 0 : _cart$totals4.productsTotalPrice) + shippingCost : cart !== null && cart !== void 0 && cart.isShippingMethodPicked || cart !== null && cart !== void 0 && (_cart$totals5 = cart.totals) !== null && _cart$totals5 !== void 0 && _cart$totals5.discount ? cart === null || cart === void 0 ? void 0 : (_cart$totals6 = cart.totals) === null || _cart$totals6 === void 0 ? void 0 : _cart$totals6.cartTotalPrice : (cart === null || cart === void 0 ? void 0 : (_cart$totals7 = cart.totals) === null || _cart$totals7 === void 0 ? void 0 : _cart$totals7.cartTotalPrice) + shippingCost;
    return _objectSpread(_objectSpread({}, cart === null || cart === void 0 ? void 0 : cart.totals), {}, {
      items: cart,
      shippingCost: shippingCost,
      cartTotalPrice: cartTotalPrice
    });
  };
  var getShippingCost = function getShippingCost() {
    var shipping = shippingMethods === null || shippingMethods === void 0 ? void 0 : shippingMethods.find(function (method) {
      return method.id === "tablerate";
    });
    return (shipping === null || shipping === void 0 ? void 0 : shipping.price) || 0;
  };
  var createCart = /*#__PURE__*/function () {
    var _ref2 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee2(localToken) {
      var cartIdCookie, actualToken, cartId;
      return _regenerator["default"].wrap(function _callee2$(_context2) {
        while (1) {
          switch (_context2.prev = _context2.next) {
            case 0:
              cartIdCookie = getCartId();
              actualToken = localToken ? localToken : cartIdCookie;
              _context2.prev = 2;
              _context2.next = 5;
              return _agent.requests.post(actualToken ? global.__appConfig__.createCustomerCartUrl : global.__appConfig__.createGuestCartUrl, {}, actualToken, languageAndDomain);
            case 5:
              cartId = _context2.sent;
              _jsCookie["default"].set("cartId", cartId, {
                expires: parseInt(global.__appConfig__.sessionUserLoginMaxDays)
              });
              localStorage.setItem("cartId", JSON.stringify(cartId));
              localStorage.setItem("minicartContent", "[]");
              return _context2.abrupt("return", cartId);
            case 12:
              _context2.prev = 12;
              _context2.t0 = _context2["catch"](2);
              handleResponseErrors(_context2.t0);
            case 15:
            case "end":
              return _context2.stop();
          }
        }
      }, _callee2, null, [[2, 12]]);
    }));
    return function createCart(_x2) {
      return _ref2.apply(this, arguments);
    };
  }();
  var addProduct = /*#__PURE__*/function () {
    var _ref3 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee3(product, quantity, isProductPageHit) {
      var _cart$items2, _cartItem$product$pri, _cartItem$product, _cartItem$product2;
      var cartIdInStorage, cartId, cart, itemAlreadyInCart, _cart$totals8, cartItemResponse, cartItem, newCart, cartItemPrice;
      return _regenerator["default"].wrap(function _callee3$(_context3) {
        while (1) {
          switch (_context3.prev = _context3.next) {
            case 0:
              cartIdInStorage = getCartIdFromStorage();
              if (!cartIdInStorage) {
                _context3.next = 5;
                break;
              }
              _context3.t0 = cartIdInStorage;
              _context3.next = 8;
              break;
            case 5:
              _context3.next = 7;
              return createCart();
            case 7:
              _context3.t0 = _context3.sent;
            case 8:
              cartId = _context3.t0;
              cart = getCartFromStorage();
              itemAlreadyInCart = cart && ((_cart$items2 = cart.items) === null || _cart$items2 === void 0 ? void 0 : _cart$items2.find(function (item) {
                return item.sku === product.sku;
              }));
              if (!itemAlreadyInCart) {
                _context3.next = 15;
                break;
              }
              _context3.next = 14;
              return updateItemQuantity(product.sku, itemAlreadyInCart.quantity + quantity, isProductPageHit, (_cart$totals8 = cart.totals) === null || _cart$totals8 === void 0 ? void 0 : _cart$totals8.couponCode);
            case 14:
              return _context3.abrupt("return", _context3.sent);
            case 15:
              _context3.prev = 15;
              _context3.next = 18;
              return _agent.requests.post(token ? global.__appConfig__.customerAddProductToCartUrl : (0, _createParametrizedUrl["default"])(global.__appConfig__.guestAddProductToCartUrl, {
                cartId: cartId
              }), {
                cartItem: {
                  quote_id: cartId,
                  sku: product.sku,
                  qty: quantity
                }
              }, token, languageAndDomain);
            case 18:
              cartItemResponse = _context3.sent;
              setItemChange(true);
              _context3.next = 26;
              break;
            case 22:
              _context3.prev = 22;
              _context3.t1 = _context3["catch"](15);
              handleResponseErrors(_context3.t1);
              throw _context3.t1;
            case 26:
              cartItem = (0, _mapCartData.mapItem)(cartItemResponse);
              cartItem.product = product;
              _context3.next = 30;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 30:
              newCart = _context3.sent;
              isProductFromPromotions(product.sku, isProductPageHit);
              if (newCart) {
                _context3.next = 35;
                break;
              }
              revalidate(!isRevalidated);
              return _context3.abrupt("return");
            case 35:
              cartItemPrice = (_cartItem$product$pri = cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product = cartItem.product) === null || _cartItem$product === void 0 ? void 0 : _cartItem$product.price.special) !== null && _cartItem$product$pri !== void 0 ? _cartItem$product$pri : cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product2 = cartItem.product) === null || _cartItem$product2 === void 0 ? void 0 : _cartItem$product2.price.regular;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice + cartItemPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice + cartItemPrice
                })
              }));
              setMinicartContentFromStorage();
            case 38:
            case "end":
              return _context3.stop();
          }
        }
      }, _callee3, null, [[15, 22]]);
    }));
    return function addProduct(_x3, _x4, _x5) {
      return _ref3.apply(this, arguments);
    };
  }();
  var updateShippingMethod = function updateShippingMethod(method, isShippingMethodPicked, billingAddress, shippingAddress) {
    setCart(_objectSpread(_objectSpread({}, cart), {}, {
      billingAddress: billingAddress,
      shippingAddress: shippingAddress,
      shippingMethodPicked: method,
      isShippingMethodPicked: isShippingMethodPicked
    }));
  };
  var refreshCart = /*#__PURE__*/function () {
    var _ref4 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee4(freshTokenAfterLogin) {
      var newCart;
      return _regenerator["default"].wrap(function _callee4$(_context4) {
        while (1) {
          switch (_context4.prev = _context4.next) {
            case 0:
              _context4.next = 2;
              return (0, _fetcher["default"])(getCartIdFromStorage(), freshTokenAfterLogin !== null && freshTokenAfterLogin !== void 0 ? freshTokenAfterLogin : token, languageAndDomain);
            case 2:
              newCart = _context4.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice
                })
              }));
              return _context4.abrupt("return");
            case 5:
            case "end":
              return _context4.stop();
          }
        }
      }, _callee4);
    }));
    return function refreshCart(_x6) {
      return _ref4.apply(this, arguments);
    };
  }();
  var updateItemQuantity = /*#__PURE__*/function () {
    var _ref5 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee5(sku, quantity, isProductPageHit, hasCouponCode) {
      var _cartItem$product$pri2, _cartItem$product3, _cartItem$product4;
      var cart, cartId, cartItem, newCart, cartItemPrice;
      return _regenerator["default"].wrap(function _callee5$(_context5) {
        while (1) {
          switch (_context5.prev = _context5.next) {
            case 0:
              cart = getCartFromStorage();
              cartId = getCartIdFromStorage();
              cartItem = cart.items.find(function (item) {
                return item.sku === sku;
              });
              if (cartItem) {
                _context5.next = 5;
                break;
              }
              throw Error("There is no product with sku ".concat(sku, " in cart"));
            case 5:
              _context5.prev = 5;
              _context5.next = 8;
              return _agent.requests.put(token ? (0, _createParametrizedUrl["default"])(global.__appConfig__.customerUpdateProductInCartUrl, {
                itemId: cartItem.itemId
              }) : (0, _createParametrizedUrl["default"])(global.__appConfig__.guestUpdateProductInCartUrl, {
                cartId: cartId,
                itemId: cartItem.itemId
              }), {
                cartItem: {
                  quote_id: cartId,
                  sku: cartItem.sku,
                  qty: quantity
                }
              }, token, languageAndDomain);
            case 8:
              _context5.next = 14;
              break;
            case 10:
              _context5.prev = 10;
              _context5.t0 = _context5["catch"](5);
              handleResponseErrors(_context5.t0);
              throw _context5.t0;
            case 14:
              cart.items.forEach(function (item) {
                if (item.sku === sku) {
                  item.quantity = quantity;
                }
              });
              setItemChange(true);
              _context5.next = 18;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 18:
              newCart = _context5.sent;
              cartItemPrice = (_cartItem$product$pri2 = cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product3 = cartItem.product) === null || _cartItem$product3 === void 0 ? void 0 : _cartItem$product3.price.special) !== null && _cartItem$product$pri2 !== void 0 ? _cartItem$product$pri2 : cartItem === null || cartItem === void 0 ? void 0 : (_cartItem$product4 = cartItem.product) === null || _cartItem$product4 === void 0 ? void 0 : _cartItem$product4.price.regular;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: parseFloat(newCart.totals.productsTotalPrice + (quantity - cartItem.quantity) * cartItemPrice).toFixed(2),
                  cartTotalPrice: parseFloat(newCart.totals.cartTotalPrice + (quantity - cartItem.quantity) * cartItemPrice).toFixed(2),
                  shippingCost: newCart.totals.shippingCost
                })
              }));
              setMinicartContentFromStorage();
              if (!hasCouponCode) {
                isProductFromPromotions(sku, isProductPageHit);
              }
            case 23:
            case "end":
              return _context5.stop();
          }
        }
      }, _callee5, null, [[5, 10]]);
    }));
    return function updateItemQuantity(_x7, _x8, _x9, _x0) {
      return _ref5.apply(this, arguments);
    };
  }();
  var removeItem = /*#__PURE__*/function () {
    var _ref6 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee6(sku) {
      var cart, cartId, cartItem, itemId, url, newCart;
      return _regenerator["default"].wrap(function _callee6$(_context6) {
        while (1) {
          switch (_context6.prev = _context6.next) {
            case 0:
              cart = getCartFromStorage();
              cartId = getCartIdFromStorage();
              cartItem = cart.items.find(function (item) {
                return item.sku === sku;
              });
              if (cartItem) {
                _context6.next = 5;
                break;
              }
              throw Error("There is no product with sku ".concat(sku, " in cart"));
            case 5:
              itemId = cartItem.itemId;
              url = token ? (0, _createParametrizedUrl["default"])(global.__appConfig__.customerRemoveProductFromCartUrl, {
                itemId: itemId
              }) : (0, _createParametrizedUrl["default"])(global.__appConfig__.guestRemoveProductFromCartUrl, {
                cartId: cartId,
                itemId: itemId
              });
              _context6.prev = 7;
              _context6.next = 10;
              return _agent.requests.del(url, token, languageAndDomain);
            case 10:
              _context6.next = 16;
              break;
            case 12:
              _context6.prev = 12;
              _context6.t0 = _context6["catch"](7);
              handleResponseErrors(_context6.t0);
              throw _context6.t0;
            case 16:
              setItemChange(true);
              _context6.next = 19;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 19:
              newCart = _context6.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                items: newCart.items.filter(function (item) {
                  return item.sku !== cartItem.sku;
                }),
                totals: _objectSpread(_objectSpread({}, newCart.totals), {}, {
                  productsTotalPrice: newCart.totals.productsTotalPrice,
                  cartTotalPrice: newCart.totals.cartTotalPrice,
                  shippingCost: newCart.totals.shippingCost
                })
              }));
              setMinicartContentFromStorage();
            case 22:
            case "end":
              return _context6.stop();
          }
        }
      }, _callee6, null, [[7, 12]]);
    }));
    return function removeItem(_x1) {
      return _ref6.apply(this, arguments);
    };
  }();
  var clearUserCartItems = /*#__PURE__*/function () {
    var _ref7 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee7() {
      var _cart$items3;
      var cart;
      return _regenerator["default"].wrap(function _callee7$(_context7) {
        while (1) {
          switch (_context7.prev = _context7.next) {
            case 0:
              if (token) {
                _context7.next = 2;
                break;
              }
              return _context7.abrupt("return");
            case 2:
              cart = getCartFromStorage();
              if (!(!(cart !== null && cart !== void 0 && cart.items) || (cart === null || cart === void 0 ? void 0 : (_cart$items3 = cart.items) === null || _cart$items3 === void 0 ? void 0 : _cart$items3.length) === 0)) {
                _context7.next = 5;
                break;
              }
              return _context7.abrupt("return");
            case 5:
              _context7.prev = 5;
              _context7.next = 8;
              return Promise.all(cart.items.map(function (item) {
                return _agent.requests.del((0, _createParametrizedUrl["default"])(global.__appConfig__.customerRemoveProductFromCartUrl, {
                  itemId: item.itemId
                }), token, languageAndDomain);
              }));
            case 8:
              localStorage.setItem("minicartContent", "[]");
              setMinicartContentFromStorage();
              _context7.next = 16;
              break;
            case 12:
              _context7.prev = 12;
              _context7.t0 = _context7["catch"](5);
              handleResponseErrors(_context7.t0);
              throw _context7.t0;
            case 16:
            case "end":
              return _context7.stop();
          }
        }
      }, _callee7, null, [[5, 12]]);
    }));
    return function clearUserCartItems() {
      return _ref7.apply(this, arguments);
    };
  }();

  // @TODO: Merge!
  var mergeCart = /*#__PURE__*/function () {
    var _ref8 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee8(guestCartItems, customerToken, customerCartId) {
      return _regenerator["default"].wrap(function _callee8$(_context8) {
        while (1) {
          switch (_context8.prev = _context8.next) {
            case 0:
              _context8.prev = 0;
              _context8.next = 3;
              return Promise.all(guestCartItems.map(function (item) {
                return _agent.requests.post(global.__appConfig__.customerAddProductToCartUrl, {
                  cartItem: {
                    quote_id: customerCartId,
                    sku: item.sku,
                    qty: item.quantity
                  }
                }, customerToken, languageAndDomain);
              }));
            case 3:
              return _context8.abrupt("return", _context8.sent);
            case 6:
              _context8.prev = 6;
              _context8.t0 = _context8["catch"](0);
              handleResponseErrors(_context8.t0);
            case 9:
            case "end":
              return _context8.stop();
          }
        }
      }, _callee8, null, [[0, 6]]);
    }));
    return function mergeCart(_x10, _x11, _x12) {
      return _ref8.apply(this, arguments);
    };
  }();
  var addCouponCode = /*#__PURE__*/function () {
    var _ref9 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee9(couponCode) {
      var checkPromotions,
        cartId,
        newCart,
        _args9 = arguments;
      return _regenerator["default"].wrap(function _callee9$(_context9) {
        while (1) {
          switch (_context9.prev = _context9.next) {
            case 0:
              checkPromotions = _args9.length > 1 && _args9[1] !== undefined ? _args9[1] : true;
              cartId = getCartIdFromStorage();
              _context9.t0 = checkPromotions;
              if (!_context9.t0) {
                _context9.next = 7;
                break;
              }
              _context9.next = 6;
              return checkCouponBeforeSendToMagento(couponCode);
            case 6:
              _context9.t0 = _context9.sent;
            case 7:
              if (!_context9.t0) {
                _context9.next = 9;
                break;
              }
              return _context9.abrupt("return");
            case 9:
              _context9.prev = 9;
              _context9.next = 12;
              return _agent.requests.put((0, _createParametrizedUrl["default"])(token ? global.__appConfig__.customerCouponUrl : global.__appConfig__.guestCouponUrl, {
                couponCode: couponCode,
                cartId: getCartId()
              }), {}, token, languageAndDomain);
            case 12:
              _context9.next = 14;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 14:
              newCart = _context9.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread({}, newCart.totals)
              }));
              _context9.t1 = setCouponCodeFormPromotions;
              _context9.next = 19;
              return isCouponFromPromotions(couponCode);
            case 19:
              _context9.t2 = _context9.sent;
              (0, _context9.t1)(_context9.t2);
              setMinicartContentFromStorage();
              _context9.next = 28;
              break;
            case 24:
              _context9.prev = 24;
              _context9.t3 = _context9["catch"](9);
              handleResponseErrors(_context9.t3);
              throw _context9.t3;
            case 28:
            case "end":
              return _context9.stop();
          }
        }
      }, _callee9, null, [[9, 24]]);
    }));
    return function addCouponCode(_x13) {
      return _ref9.apply(this, arguments);
    };
  }();
  var deleteCouponCode = /*#__PURE__*/function () {
    var _ref0 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee0() {
      var cartId, newCart;
      return _regenerator["default"].wrap(function _callee0$(_context0) {
        while (1) {
          switch (_context0.prev = _context0.next) {
            case 0:
              cartId = getCartIdFromStorage();
              _context0.prev = 1;
              _context0.next = 4;
              return _agent.requests.del((0, _createParametrizedUrl["default"])(token ? global.__appConfig__.deleteCustomerCouponUrl : global.__appConfig__.deleteGuestCouponUrl, {
                cartId: getCartId()
              }), token, languageAndDomain);
            case 4:
              _context0.next = 6;
              return (0, _fetcher["default"])(cartId, token, languageAndDomain);
            case 6:
              newCart = _context0.sent;
              setCart(_objectSpread(_objectSpread({}, newCart), {}, {
                totals: _objectSpread({}, newCart.totals)
              }));
              setCouponCodeFormPromotions(false);
              setMinicartContentFromStorage();
              _context0.next = 15;
              break;
            case 12:
              _context0.prev = 12;
              _context0.t0 = _context0["catch"](1);
              handleResponseErrors(_context0.t0);
            case 15:
            case "end":
              return _context0.stop();
          }
        }
      }, _callee0, null, [[1, 12]]);
    }));
    return function deleteCouponCode() {
      return _ref0.apply(this, arguments);
    };
  }();
  var truncateCart = /*#__PURE__*/function () {
    var _ref1 = (0, _asyncToGenerator2["default"])(/*#__PURE__*/_regenerator["default"].mark(function _callee1() {
      return _regenerator["default"].wrap(function _callee1$(_context1) {
        while (1) {
          switch (_context1.prev = _context1.next) {
            case 0:
              _jsCookie["default"].remove("cartId");
              removeMinicartDataFromStorage();
              _context1.next = 4;
              return updateCart(null, false);
            case 4:
              _context1.next = 6;
              return createCart(token);
            case 6:
            case "end":
              return _context1.stop();
          }
        }
      }, _callee1);
    }));
    return function truncateCart() {
      return _ref1.apply(this, arguments);
    };
  }();
  var clearCart = function clearCart() {
    var _ref10 = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {},
      _ref10$removeMinicart = _ref10.removeMinicart,
      removeMinicart = _ref10$removeMinicart === void 0 ? false : _ref10$removeMinicart;
    setCart(null);
    _jsCookie["default"].remove(global.__appConfig__.shippingMethodIdCookieName);
    if (removeMinicart) {
      _jsCookie["default"].remove("cartId");
      removeMinicartDataFromStorage();
      clearAccountData();
    }
  };
  var _usePromotions = (0, _usePromotions2["default"])({
      cart: cart,
      getCartId: getCartId,
      addCouponCode: addCouponCode,
      addProduct: addProduct
    }),
    checkCouponBeforeSendToMagento = _usePromotions.checkCouponBeforeSendToMagento,
    isProductFromPromotions = _usePromotions.isProductFromPromotions,
    isCouponFromPromotions = _usePromotions.isCouponFromPromotions;
  return __jsx(CartContext.Provider, {
    value: {
      getCartTotals: getCartTotals,
      addCouponCode: addCouponCode,
      deleteCouponCode: deleteCouponCode,
      cart: cart,
      shippingCost: getShippingCost(),
      updateShippingMethod: updateShippingMethod,
      handleResponseErrors: handleResponseErrors,
      getCartId: getCartId,
      truncateCart: truncateCart,
      createCart: createCart,
      mergeCart: mergeCart,
      fetchCart: _fetcher["default"],
      updateItemQuantity: updateItemQuantity,
      addProduct: addProduct,
      removeItem: removeItem,
      refreshCart: refreshCart,
      shippingMethods: shippingMethods,
      productsWithQuantity: productsWithQuantity,
      setProductsWithQuantity: setProductsWithQuantity,
      clearCart: clearCart,
      clearUserCartItems: clearUserCartItems
    }
  }, children);
}
function useCart() {
  var context = (0, _react.useContext)(CartContext);
  if (!context) {
    throw new Error("useCart must be used within a CartProvider");
  }
  return context;
}
var _default = CartProvider;
exports["default"] = _default;